export default __webpack_public_path__ + "4df6a49bc75f70970c6241781ea4d334.jpg";